class LicenseGroup {
  /** Массив лицензий структуры License */
  list = [];

  /**
   * Если false, то поля endDate и remainingDays можно считывать.
   * Иначе они не будут иницилизированы
   */
  separateDates;

  /** Дата окончания для всех лицензий в группе */
  endDate;

  /** Количество оставшихся дней для всех лицензий в группе */
  remainingDays;

  constructor({ separateDates }) {
    this.separateDates = separateDates;
  }

  get isEmpty() {
    return this.list.length === 0;
  }

  addLicense(license) {
    this.list.push(license);
  }
}

export default LicenseGroup;
